// extracted by mini-css-extract-plugin
export default {"yoPillsNavLink":"YoPills_yoPillsNavLink__T5GnS"};